import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logOffRequest } from 'store/modules/api/sgu/loginUnico/actions';
import { changeUrlClear } from 'store/modules/api/eCpf/changeUrl/actions';
import { FaSignOutAlt } from 'react-icons/fa';
import { Button, Icon, Text } from './styled';

const { origin } = window.location;

interface IEnvConfig {
	env: string;
	idpDomain: string;
}

const prodConfig: IEnvConfig = {
	env: 'prd',
	idpDomain: 'https://idp.sp.gov.br',
};

const envConfigs: { [key: string]: IEnvConfig } = {
	'https://www.homologa.poupatempo4g.sp.gov.br': {
		env: 'hml',
		idpDomain: 'https://rhsso.idp-hml.sp.gov.br',
	},
	'https://www.poupatempo4g.des.sp.gov.br': {
		env: 'des',
		idpDomain: 'https://rhsso.idp-hml.sp.gov.br',
	},
	'http://localhost:3000': {
		env: 'hml',
		idpDomain: 'https://rhsso.idp-hml.sp.gov.br',
	},
	'https://10.200.13.36': {
		env: 'hml',
		idpDomain: 'https://rhsso.idp-hml.sp.gov.br',
	},
	'https://10.200.13.37': {
		env: 'hml',
		idpDomain: 'https://rhsso.idp-hml.sp.gov.br',
	},
	'https://www.poupatempo4g.sp.gov.br': prodConfig,
};

const currentConfig = envConfigs[origin] || prodConfig;

const LogoutButton: React.FC = () => {
	const history = useHistory();
	const dispatch = useDispatch();

	const getRawIdToken = () => {
		const stored = localStorage.getItem('ROCP_idToken');
		if (!stored) return null;
		if (stored.startsWith('"') && stored.endsWith('"')) {
			return stored.slice(1, -1);
		}
		return stored;
	};

	const logoutViaPost = (
		logoutUrl: string,
		idToken: string,
		redirectUri: string,
	) => {
		const form = document.createElement('form');
		form.method = 'POST';
		form.action = logoutUrl;

		const inputToken = document.createElement('input');
		inputToken.type = 'hidden';
		inputToken.name = 'id_token_hint';
		inputToken.value = idToken;
		form.appendChild(inputToken);

		const inputRedirect = document.createElement('input');
		inputRedirect.type = 'hidden';
		inputRedirect.name = 'post_logout_redirect_uri';
		inputRedirect.value = redirectUri;
		form.appendChild(inputRedirect);

		document.body.appendChild(form);
		form.submit();
	};

	const handleLogout = useCallback(async () => {
		const activeFlow = sessionStorage.getItem('active_flow');
		const isMinhaArea = activeFlow && activeFlow.includes('CYBERARK');
		const idToken = getRawIdToken();

		dispatch(changeUrlClear());
		dispatch(logOffRequest());

		if (isMinhaArea) {
			console.log('Logout: Minha Área -> Plataforma SP');
			localStorage.clear();
			sessionStorage.clear();
			window.location.href = '/';
			// window.location.href = `https://${currentConfig.env}.minhaarea.sp.gov.br/plataformasp`;
		} else {
			console.log('Logout: Gov.br (POST Seguro)');

			if (idToken) {
				const logoutUrl = `${currentConfig.idpDomain}/auth/realms/idpsp/protocol/openid-connect/logout`;

				localStorage.clear();
				sessionStorage.clear();

				logoutViaPost(logoutUrl, idToken, window.location.origin);
			} else {
				console.log('Logout: Token não encontrado, apenas limpando.');
				localStorage.clear();
				sessionStorage.clear();
				history.push('/');
				window.location.reload();
			}
		}
	}, [dispatch, history]);

	return (
		<Button type="button" onClick={handleLogout}>
			<Icon>
				<FaSignOutAlt />
			</Icon>
			<Text>Sair</Text>
		</Button>
	);
};

export default LogoutButton;
